import React, { PureComponent, Fragment, createRef } from "react";
import Input from '../input';
import Icon from '../icon';
import Modal from '../modal';
import PropTypes from 'prop-types';

interface IModalProps {
  onOk: ((val) => void);
  render: ((val) => React.ReactNode);
  title: string;
  visible: boolean;

}
type PEProps = {
  value?: any,
  defaultValue?: any,
  dataTextField?: string,
  dataValueField?: string,
  disabled: boolean,
  onChange?: ((val) => void);
  onClear?: (() => void);
  modalProps?: IModalProps;
  inputProps?: any;
  className?: string;
}
type PEState = {
  isVisible: boolean;
  inputObj: any;
  inputVal: string;
  currentValue: any;
}

const defaultModalProps = {
  title: 'Title',
  visible: true
}

class PopEdit extends PureComponent<PEProps, PEState> {
  static propTypes = {
    inputProps: PropTypes.object,
    formProps: PropTypes.object,
    modalProps: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const { value, defaultValue } = props;
    const defalutObj = value ? this.setValue(value) : (defaultValue ? this.setValue(defaultValue) : null);
    const defaultVal = this.formmatInputVal(defalutObj);
    this.state = {
      isVisible: false,
      inputObj: defalutObj,
      inputVal: defaultVal || '',
      currentValue: defalutObj,
    }
  }

  inputRef = createRef();

  componentDidMount() {
    this.clearListener();
  }

  componentDidUpdate(prevProps) {
    const { value, onChange } = this.props
    const newVal = JSON.stringify(this.setValue(value))
    const oldVal = JSON.stringify(this.setValue(prevProps.value))
    if (newVal !== oldVal) {
      onChange && onChange(value)
    }
    this.setState({
      currentValue: value
    });
    this.clearListener();
  }

  clearListener = () => {
    if (!this.props.inputProps?.allowClear) return;
    if (this.inputRef?.current?.input?.nextSibling?.children?.length > 1) {
      let closeIcon = null;
      const htmlNodes = this.inputRef.current.input.nextSibling.children;
      for (let i = 0; i < htmlNodes.length; i++ ){
          if (htmlNodes[i]?.attributes?.getNamedItem('aria-label')?.value?.includes('close-circle')) { // ariaLabel='icon: close-circle' 里面的 'icon' 会被国际化
          closeIcon = htmlNodes[i];
        }
      }
      if (closeIcon && closeIcon?.onclick?.name !== 'fdxPopeditClear') { // 初始绑定的是一个名为 noop 的方法, 啥也不干; 当运行完下面的代码后 onclick.name 为 fdxPopeditClear
        const _this = this;
        closeIcon.onclick = function fdxPopeditClear() {
          _this.setState({
            inputObj: undefined,
            inputVal: undefined,
            currentValue: undefined,
          })
          if (_this.props.onClear) _this.props.onClear();
        }
      }
    }
  }

  setValue = (values) => {
    if (Array.isArray(values)) {
      return values.map(value => {
        return this.formatValue(value)
      })
    } else {
      return this.formatValue(values)
    }
  }

  formatValue = (val) => {
    const { dataTextField = 'name', dataValueField = 'value' } = this.props
    if (typeof val === 'number') {
      return { [dataTextField]: val.toString(), [dataValueField]: val }
    } else if (typeof val === 'string') {
      return { [dataTextField]: val, [dataValueField]: val }
    } else {
      return val ? { [dataTextField]: val[dataTextField], [dataValueField]: val[dataValueField] } : val
    }
  }

  formmatInputVal = (valueObj) => {
    const { dataTextField = 'name' } = this.props
    if (valueObj && Array.isArray(valueObj)) {
      const valArr = valueObj.map(val => {
        return val[dataTextField]
      })
      return valArr.join('/')
    } else {
      return valueObj?.[dataTextField]
    }
  }

  onOpen = () => {
    const { value, disabled = false } = this.props;
    const curInputObj = this.setValue(value)
    if (!disabled) {
      this.setState(prevState => {
        return {
          isVisible: true,
          inputObj: curInputObj || prevState.inputObj,
          inputVal: this.formmatInputVal(curInputObj) || prevState.inputVal,
        };
      });
    }
  }

  handleCancel = () => {
    this.setState({
      isVisible: false
    });
  }

  handleOk = () => {
    const { modalProps: { onOk }, onChange } = this.props;
    onOk && onOk(this.state.inputObj);
    onChange && JSON.stringify(this.state.inputObj) !== JSON.stringify(this.state.currentValue) && onChange(this.state.inputObj);
    const curInputObj = this.setValue(this.state.inputObj)
    this.setState({
      isVisible: false,
      inputVal: this.formmatInputVal(curInputObj)
    })
  }

  handleValue = val => {
    this.setState({
      inputObj: this.setValue(val)
    });
  }

  renderInput = () => {
    const { inputProps, disabled = false, className = '' } = this.props;
    const value = this.setValue(this.props.value)
    const defaultValue = this.setValue(this.props.defaultValue)
    const defaultInputProps = disabled ? {
      ...inputProps,
      value: defaultValue && this.formmatInputVal(defaultValue) ? this.formmatInputVal(defaultValue) : this.formmatInputVal(value),
      disabled
    } : {
        ...inputProps,
        value: value ? this.formmatInputVal(value) : this.state.inputVal,
      }
    let inputRender = <Input ref={this.inputRef} {...defaultInputProps} className={className} suffix={<Icon type="select" onClick={this.onOpen} />} onClick={this.onOpen} readOnly />;
    return inputRender;
  }

  render() {
    const { modalProps } = this.props;
    const { isVisible } = this.state;
    const modalNewProps = {
      ...defaultModalProps,
      onCancel: this.handleCancel
    }
    Object.keys(modalProps).forEach(key => {
      if (key !== 'render' && key !== 'onOk') modalNewProps[key] = modalProps[key]
    })
    return (
      <Fragment>
        {this.renderInput()}
        {isVisible && (
          <Modal
            visible
            {...modalNewProps}
            onOk={() => this.handleOk()}
          >
            {modalProps.render(this.handleValue)}
          </Modal>
        )}
      </Fragment>
    );
  }
}

export default PopEdit;



// WEBPACK FOOTER //
// ./src/components/pop-edit/index.tsx